module.exports = __webpack_public_path__ + "img/icon06.ff9a40b4.png";